import pick from 'lodash.pick';
import {
  CustomizeRequest,
  DoorsRequest,
  MakeRequest,
  ModelVersionRequest,
  ParentModelRequest,
  TrimRequest,
  YearRequest
} from '~/contracts/new-cars';

export default function pickRequestProps<
  T extends
    | CustomizeRequest
    | DoorsRequest
    | MakeRequest
    | ModelVersionRequest
    | ParentModelRequest
    | TrimRequest
    | YearRequest
>(request: T): T {
  return pick(
    Object.fromEntries(Object.entries(request).filter(([, v]) => v)),
    [
      'doorCount',
      'driveType',
      'engineCode',
      'exteriorColorCode',
      'interiorColorCode',
      'make',
      'modelVersion',
      'packageOptionCodes',
      'parentModel',
      'trim',
      'truckBodyStyle',
      'year',
      'zipcode'
    ]
  ) as T;
}
